type RedirectTokenLimitInput = {
  maxTokens: number
  totalTokenCount: number
  reportedComposerTokenCount: number
  clearedRedirectBaseTokenCount: number | null
  hasLiveComposerText: boolean
  redirectTokenCount: number
}

const FRONTEND_SAFETY_MARGIN = 6000

export function isRedirectOverTokenLimit({
  maxTokens,
  totalTokenCount,
  reportedComposerTokenCount,
  clearedRedirectBaseTokenCount,
  hasLiveComposerText,
  redirectTokenCount,
}: RedirectTokenLimitInput): boolean {
  const nonComposerTokenCount = hasLiveComposerText
    ? Math.max(0, totalTokenCount - reportedComposerTokenCount)
    : (clearedRedirectBaseTokenCount ?? totalTokenCount)
  const wouldExceed = nonComposerTokenCount + redirectTokenCount > maxTokens
  const textOverHardLimit = redirectTokenCount > maxTokens - FRONTEND_SAFETY_MARGIN
  return wouldExceed && textOverHardLimit
}
